// Ship name generator: seeded, deterministic, always two words
// (ADJECTIVE + NOUN), in the grand/ominous space-opera register of Master
// of Orion III's capital-ship names — "Eternal Vigil", "Sundered Dominion".
// Same seed → same name, so the name rerolls together with the hull it
// christens. The two pools are disjoint on purpose: "Ember Ember" can never
// happen. Displayed UPPERCASE to match the captain name plate.

function mulberry32(seed: number): () => number {
  let s = seed >>> 0;
  return () => {
    s = (s + 0x6D2B79F5) >>> 0;
    let t = s;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

const ADJECTIVES: readonly string[] = [
  'Crimson', 'Silent', 'Burning', 'Hollow', 'Radiant', 'Umbral',
  'Obsidian', 'Celestial', 'Iron', 'Pale', 'Astral', 'Storm',
  'Solar', 'Lunar', 'Ghost', 'Grim', 'Azure', 'Scarlet',
  'Ashen', 'Ebon', 'Gilded', 'Frozen', 'Raging', 'Spectral',
  'Twilight', 'Vengeful', 'Eternal', 'Sable', 'Cobalt', 'Amber',
  'Ivory', 'Distant', 'Howling', 'Sundered', 'Midnight', 'Sovereign',
];

const NOUNS: readonly string[] = [
  'Vigil', 'Requiem', 'Horizon', 'Promise', 'Hammer', 'Choir',
  'Lantern', 'Herald', 'Thorn', 'Vector', 'Whisper', 'Anvil',
  'Scepter', 'Spear', 'Fang', 'Warden', 'Omen', 'Beacon',
  'Talon', 'Crescent', 'Meridian', 'Zenith', 'Eclipse', 'Bastion',
  'Kestrel', 'Leviathan', 'Seraph', 'Vanguard', 'Oracle', 'Nomad',
  'Pilgrim', 'Tempest', 'Covenant', 'Dominion', 'Paragon', 'Emissary',
];

/** Deterministic two-word ship name for a hull seed, e.g. "SILENT REQUIEM". */
export function rollShipName(seed: number): string {
  const rng = mulberry32(seed);
  const adjective = ADJECTIVES[Math.floor(rng() * ADJECTIVES.length)];
  const noun = NOUNS[Math.floor(rng() * NOUNS.length)];
  return `${adjective} ${noun}`.toUpperCase();
}
